import { ClassName, Dialog, IDialogProps, Theme, Tray } from '@busybusy/webapp-react-ui';
import { CloseIcon } from 'assets/icons';
import classNames from 'classnames';
import { Header, IconButton, Panel } from 'components';
import { t } from 'utils/localize';
import WistiaVideoEmbed from '../WistiaVideoEmbed/WistiaVideoEmbed';
import './WistiaVideoEmbedDialog.scss';

export interface IWistiaVideoEmbedDialogProps extends Omit<IDialogProps, 'size' | 'hasDismiss' | 'children'> {
  isOpen: boolean;
  onClose: () => void;
  videoId: string;
  className?: ClassName;
}

export default function WistiaVideoEmbedDialog({
  videoId,
  className,
  onClose,
  ...dialogProps
}: IWistiaVideoEmbedDialogProps) {
  const classes = classNames('wistia-video-embed-dialog', className);

  return (
    <Dialog hasDismiss={false} size="full" {...dialogProps} className={classes}>
      <Panel>
        <Header>
          <Tray>
            <IconButton svg={CloseIcon} theme={Theme.DARK} onClick={onClose} tooltipLabel={t('Close')} />
          </Tray>
        </Header>
        <div className="wistia-container">
          <WistiaVideoEmbed videoId={videoId} />
        </div>
      </Panel>
    </Dialog>
  );
}
